import { uri } from '../../api-endpoint';
import { IProjectImageInfoFromAPISuccessResponse } from '../../type-conversion/project-image-info/from-api-repsonse';
import { fetchListTemplateFn } from '../common';

export const fetchProjectImageListAPI = (token: string) => (
  projectId: number
) =>
  fetchListTemplateFn(
    token,
    uri.projectImageList(projectId),
    IProjectImageInfoFromAPISuccessResponse
  );
